import React from 'react';

export const Minimize = () => (
    <>
        <path d='M15 19v-2a2 2 0 0 1 2 -2h2' />
        <path d='M15 5v2a2 2 0 0 0 2 2h2' />
        <path d='M5 15h2a2 2 0 0 1 2 2v2' />
        <path d='M5 9h2a2 2 0 0 0 2 -2v-2' />
    </>
);